// Models
import { PaginationPayload } from 'app/shared/pagination/models';
import { FetchOverriddenEntitiesPayload } from 'app/modules/riskRatings/queries/useFetchOverriddenEntitiesByRiskModel';
import { GetRiskModelsListPayload } from 'app/modules/riskRatings/queries/useFetchEntitiesByRiskModel';

const BASE = ['risk'] as const;
export const RISK_QUERY_KEYS = {
  listRiskModels: (payload: PaginationPayload) =>
    [...RISK_QUERY_KEYS.listRiskModelsBase(), payload] as const,
  listRiskModelsBase: () => [...BASE, 'list'] as const,
  getRiskModel: (modelId: number) => [...BASE, 'get', modelId] as const,
  getRiskModelDistribution: (modelId: number) =>
    [...BASE, 'distribution', modelId] as const,
  getEntityRiskScore: (entityExternalId: string) =>
    [...BASE, 'entity', entityExternalId] as const,
  getActiveRiskModel: () => [...BASE, 'active-risk-model'] as const,
  fetchEntitiesByRiskModel: (payload: GetRiskModelsListPayload) =>
    [...BASE, 'entities-by-model-list', payload] as const,
  fetchOverriddenEntitiesByRiskModelBase: () =>
    [...BASE, 'overridden-entities'] as const,
  fetchOverriddenEntitiesByRiskModel: (
    id: number,
    payload: FetchOverriddenEntitiesPayload,
  ) =>
    [
      ...RISK_QUERY_KEYS.fetchOverriddenEntitiesByRiskModelBase(),
      id,
      payload,
    ] as const,
};
